<div class="data-sources-adaptive" #accordionRef></div>
